import {
  PageContainer,
  SecondaryContainer as CommonContainer,
} from "components";
import { BookComponent } from "./components";
import { replaceIfNotExist } from "utils/newFunction";

// /books/6435383e1ca1a/نشریات-گروه-مهندسی-برق
function Books({ data }) {
  return (
    <PageContainer
      breadCrumb={data?.breadcrumb}
      metaTag={replaceIfNotExist(data?.metaTag, data?.seo)}
      changeLanguageLink={data?.changeLanguageLink}
      noIndex={data?.noIndex}
    >
      <CommonContainer>
        <BookComponent data={data} />
      </CommonContainer>
    </PageContainer>
  );
}

export default Books;
